class ProductOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("aria-listbox:change", (e) => {
      if (this.querySelector(".product-form__option-selected-value")) {
        this.querySelector(".product-form__option-selected-value").innerHTML =
          e.target.dataset.optionValue;
      }

      this.querySelector('[name^="option-"]').value = e.target.dataset.value;

      this.querySelector("option-popup-trigger").innerHTML =
        e.target.dataset.optionValue;
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("product-option")) {
  customElements.define("product-option", ProductOption);
}
